/* eslint-disable func-names */
module.exports = [
  '$compile',
  ($compile) => ({
    restrict: 'A',
    link(scope, element, attrs) {
      element.html(scope.$eval(attrs.compileInline));
      $compile(element.contents())(scope);
    },
  }),
];
